import { render } from "./ModalNewUser.vue?vue&type=template&id=8c254230"
import script from "./ModalNewUser.vue?vue&type=script&lang=js"
export * from "./ModalNewUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__